import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const getBorderColorFromBg = bg => bg.replace('bg', 'border-color');
const RuleConnector = props => {
    const { placement, icon, hidden, background, pageBackground, contentClassName, hasBorder, borderColor, className, children } = props, remainingProps = __rest(props, ["placement", "icon", "hidden", "background", "pageBackground", "contentClassName", "hasBorder", "borderColor", "className", "children"]);
    const wrapperClassNames = classNames('RuleConnector', 'height-20', 'display-flex', `justify-content-${placement}`, 'align-items-center', 'position-relative', hidden && 'opacity-0', className);
    const commonRoundedClasses = classNames('width-20', 'height-20', 'rounded-circle', 'position-relative', 'z-index-2', 'box-sizing-content-box');
    const commonRoundedBorderClippingClasses = classNames('position-relative', 'width-20', 'height-20');
    const leftRoundedBox = classNames('margin-right--10', commonRoundedClasses, pageBackground, hasBorder && `border ${borderColor}`);
    const leftRoundedBoxBorderClipping = classNames('right-50pct', commonRoundedBorderClippingClasses, pageBackground);
    const contentWrapperClassNames = classNames('padding-left-20 padding-right-20', 'z-index-1', background, hasBorder && `border ${getBorderColorFromBg(background)}`);
    const rightRoundedBox = classNames('margin-left--10', commonRoundedClasses, pageBackground, hasBorder && `border ${borderColor}`);
    const rightRoundedBoxBorderClipping = classNames('left-50pct', commonRoundedBorderClippingClasses, pageBackground);
    return (_jsxs("div", Object.assign({ "data-testid": 'ruleConnector' }, remainingProps, { className: wrapperClassNames }, { children: [_jsx("div", Object.assign({ className: leftRoundedBox }, { children: _jsx("div", { className: leftRoundedBoxBorderClipping }) })), _jsx("span", Object.assign({ className: contentWrapperClassNames }, { children: _jsx("span", Object.assign({ className: contentClassName }, { children: children ? children : _jsx("span", { className: `rioglyph ${icon}`, "data-testid": 'ruleConnectorIcon' }) })) })), _jsx("div", Object.assign({ className: rightRoundedBox }, { children: _jsx("div", { className: rightRoundedBoxBorderClipping }) }))] })));
};
RuleConnector.START = 'start';
RuleConnector.CENTER = 'center';
RuleConnector.END = 'end';
RuleConnector.defaultProps = {
    placement: 'center',
    icon: 'rioglyph-plus',
    hidden: false,
    background: 'bg-lightest',
    pageBackground: 'bg-white',
    contentClassName: 'text-color-light',
    hasBorder: false,
    borderColor: '',
    className: '',
};
RuleConnector.propTypes = {
    placement: PropTypes.oneOf([RuleConnector.START, RuleConnector.CENTER, RuleConnector.END]),
    icon: PropTypes.string,
    hidden: PropTypes.bool,
    background: PropTypes.string,
    pageBackground: PropTypes.string,
    contentClassName: PropTypes.string,
    hasBorder: PropTypes.bool,
    borderColor: PropTypes.string,
    className: PropTypes.string,
};
export default RuleConnector;
